ScoreTrekBattle.League = ScoreTrekBattle.League || {};

ScoreTrekBattle.League.Select = (function() {
    var _this;

    function renderItem(text, icon, shortName, isLogo) {
        var parts;

        parts = [];

        if (icon) {
            parts.push(`<span class="league-select-icon${isLogo ? ' is-logo' : ''}" style="background-image:url('${icon}')"></span>`);
        }

        if (shortName) {
            parts.push(`<span><span class="league-select-shortname">${__escapeHTML(shortName)}</span><span class="league-select-text">${__escapeHTML(text)}</span></span>`);
        } else {
            parts.push(`<span class="league-select-text">${__escapeHTML(text)}</span>`);
        }

        return $(`<span class="league-select-item">${parts.join('')}</span>`);
    }

    function formatOption(option) {
        var text, icon, shortName, isLogo, formatted;

        if (!option || (typeof option !== 'object') || !option.text) {
            return option;
        }

        text = option.text;
        // A country carries a flag, a federation a logo — both render as the
        // option's leading icon, but a logo must not be cropped to a circle.
        icon = option.flag || option.logo || '';
        shortName = option.shortName || '';
        isLogo = !option.flag && !!option.logo;

        formatted = (!icon && !shortName)
            ? {text: text}
            : {text: text, $html: renderItem(text, icon, shortName, isLogo)};

        if (option.indent) {
            formatted.indent = option.indent;
        }

        return formatted;
    }

    function formatOptions(values) {
        var result;

        if (Array.isArray(values)) {
            return values.map(group => {
                var options;

                options = {};

                Object.keys(group.options).forEach(key => {
                    options[key] = formatOption(group.options[key]);
                });

                return {
                    label: group.label,
                    options: options
                };
            });
        }

        result = {};

        Object.keys(values || {}).forEach(key => {
            result[key] = formatOption(values[key]);
        });

        return result;
    }

    _this = {
        renderItem: renderItem,
        formatOption: formatOption,
        formatOptions: formatOptions
    };

    return _this;
})();
